import type { AccountDetailsTab } from '@/portfolio/account-details/account-details-types'

import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface AccountDetailsConfig {
  activeTab: AccountDetailsTab
}

export interface AccountDetailsState {
  config: AccountDetailsConfig
  configVersion: string
  selectedBond: string | null
}

const initialState: AccountDetailsState = {
  config: {
    activeTab: 'Summary',
  },
  configVersion: '1.0',
  selectedBond: null,
}

const accountDetailsSlice = createSlice({
  name: 'accountDetails',
  initialState,
  reducers: {
    initializeAccountDetailsConfig: (
      state,
      action: PayloadAction<{
        config: AccountDetailsConfig
        version: string
        selectedBond?: string | null
      }>,
    ) => {
      state.config = action.payload.config
      state.configVersion = action.payload.version
      state.selectedBond =
        action.payload.selectedBond ?? initialState.selectedBond
    },
    resetAccountDetailsConfig: () => {
      return initialState
    },
    setAccountDetailsConfig: (
      state,
      action: PayloadAction<AccountDetailsConfig>,
    ) => {
      state.config = action.payload
    },
    setActiveTab: (state, action: PayloadAction<AccountDetailsTab>) => {
      state.config.activeTab = action.payload
    },
    setSelectedBond: (state, action: PayloadAction<string>) => {
      state.selectedBond = action.payload
    },
  },
})

export const {
  initializeAccountDetailsConfig,
  resetAccountDetailsConfig,
  setAccountDetailsConfig,
  setActiveTab,
  setSelectedBond,
} = accountDetailsSlice.actions

// biome-ignore lint/style/noDefaultExport: Existing default export — prefer named exports for new code
export default accountDetailsSlice
